import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d6266e4e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  ref: "upload"
};
const _hoisted_2 = {
  class: "file-uploader-icon"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 2,
  class: "avatar-uploader-icon"
};
const _hoisted_6 = {
  class: "imgText"
};
const _hoisted_7 = {
  key: 2,
  class: "fileName"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_upload = _resolveComponent("el-upload");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.type === "file" ? (_openBlock(), _createBlock(_component_el_upload, {
    key: 0,
    class: "upload-file",
    action: $props.action,
    headers: _ctx.headers,
    "show-file-list": false,
    "on-success": _ctx.handleFileSuccess,
    "before-upload": _ctx.beforeAvatarUpload
  }, {
    default: _withCtx(() => [_createElementVNode("i", _hoisted_2, [_createVNode(_component_Plus, {
      style: {
        "width": "1em",
        "height": "1em"
      }
    })])]),
    _: 1
  }, 8, ["action", "headers", "on-success", "before-upload"])) : (_openBlock(), _createBlock(_component_el_upload, {
    key: 1,
    class: "avatar-uploader",
    action: "/ty-iot-manage/api/v1/file/upload",
    headers: _ctx.headers,
    "show-file-list": false,
    "on-success": _ctx.handleAvatarSuccess,
    "before-upload": _ctx.beforeAvatarUpload,
    name: "file"
  }, {
    default: _withCtx(() => [_ctx.url != '' ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: _ctx.url,
      class: "avatar"
    }, null, 8, _hoisted_3)) : $props.fileList && $props.fileList.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 1
    }, _renderList(_ctx.fileListAll, file => {
      return _openBlock(), _createElementBlock("img", {
        key: file,
        src: file,
        class: "avatar"
      }, null, 8, _hoisted_4);
    }), 128)) : _createCommentVNode("", true), !$props.fileList || $props.fileList.length == 0 ? (_openBlock(), _createElementBlock("i", _hoisted_5, [_createVNode(_component_Plus, {
      style: {
        "width": "1em",
        "height": "1em",
        "margin-right": "8px"
      }
    })])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["headers", "on-success", "before-upload"])), _createElementVNode("span", _hoisted_6, _toDisplayString($props.uploadTip), 1), $props.type === 'file' && $setup.fileName ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.fileName), 1)) : _createCommentVNode("", true)], 512);
}